export default "__VITE_ASSET__F2TEoj$s__"